export const CLASS_NAMES = {
    // eslint-disable-line no-unused-vars
    user: 'user',
    patient: 'patient',
    note: 'note',
    instrument: 'instrument',
    treatment: 'treatment',
    slide: 'slide',
    well: 'well',
    run: 'run',
    focal: 'focal'
}

export const WELL_STATUS = {
    // eslint-disable-line no-unused-vars
    PENDING: 'PENDING',
    FROZEN: 'FROZEN',
    THAWED: 'THAWED',
    TRANSFERRED: 'TRANSFERRED',
    DISCARDED: 'DISCARDED'
}

export const FERT_METHOD = {
    // eslint-disable-line no-unused-vars
    ICSI: 'ICSI',
    IVF: 'IVF',
    PICSI: 'PICSI',
    IMSI: 'IMSI',
    PIMSI: 'PIMSI',
    NA: 'NA'
}
